import { useFormik } from "formik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const shipmentFilterStore = makeObservable({});
const shipmentNavigationStore = createSearchResultNavigationStore();
const useShipmentFilters = () => {
  const formik = useFormik({
    initialValues: {
      limit: 50,
      offset: 0,
      tab: "items",
      sort1: { operator: "ASC" },
      sort2: { operator: "ASC" },
      sort3: { operator: "ASC" },
    },
  });

  const filterKeys = ["tab"];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    // convert formik values to filter and update store
    shipmentFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export { shipmentFilterStore, shipmentNavigationStore, useShipmentFilters };
